import React from "react";
import { FormattedMessage } from "react-intl";
import { useSelector } from "react-redux";
import { OrderInterface } from "../../../interfaces/orders";
import BoughtOrderCard from "../cards/boughtOrder";
import Spinner from "../../vapor/spinner";
import "./style.scss";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useNavigate } from "react-router-dom";
import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Typography,
} from "@vapor/react-material";

interface BoughtDocumentsHeaderProps {
    expanded?: boolean;
    setExpanded?: (val: boolean) => void;
}

const BoughtDocumentsHeader = (props: BoughtDocumentsHeaderProps) => {
    const orders = useSelector((state: RootState) => state.search.orders.data);
    const products = useSelector((state: RootState) => state.products.data);
    const isGettingOrders = useSelector(
        (state: RootState) => state.search.orders.isGettingOrders,
    );
    const isGettingProducts = useSelector(
        (state: RootState) => state.products.isGettingProducts,
    );
    const navigate = useNavigate();

    return (
        <div
            className={
                "bis-bought-documents-header-root" +
                (props.expanded ? " expanded" : "") +
                (!isGettingOrders && !isGettingProducts && orders.length === 0
                    ? " no-orders"
                    : "")
            }
        >
            {(isGettingOrders || isGettingProducts) && (
                <div className="bis-bought-documents-header-spinner">
                    <Spinner />
                </div>
            )}
            {!isGettingOrders && !isGettingProducts && orders.length === 0 && (
                <div className="bis-bought-documents-header-no-orders">
                    <div>
                        <FormattedMessage id="main.titles.noOrdersTitle" />
                    </div>
                    <div>
                        <FormattedMessage id="main.titles.noOrdersSubtitle" />
                    </div>
                </div>
            )}
            {!isGettingOrders && !isGettingProducts && orders.length > 0 && (
                <div className="bis-bought-documents-header-orders">
                    <Accordion
                        className="bis-bought-documents-header-orders-accordion"
                        expanded={props.expanded}
                        onChange={() => props.setExpanded?.(!props.expanded)}
                    >
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel1a-content"
                            id="panel1a-header"
                            className="bis-bought-documents-header-orders-accordion-summary"
                        >
                            <Typography
                                variant="titleSmall"
                                className="bis-bought-documents-header-orders-accordion-title"
                            >
                                <FormattedMessage id="orders.lastOrders" />
                            </Typography>
                            <Typography
                                variant="body"
                                className="bis-bought-documents-header-orders-accordion-description"
                            >
                                {orders.length > 4 && props.expanded && (
                                    <div onClick={() => navigate("/documenti")}>
                                        <FormattedMessage id="general.showAll" />
                                    </div>
                                )}
                            </Typography>
                        </AccordionSummary>
                        <AccordionDetails className="bis-bought-documents-header-orders-accordion-details">
                            <Typography variant="body">
                                <div className="bis-bought-documents-header-orders-results">
                                    {orders
                                        ?.filter(
                                            (order: any) =>
                                                (products
                                                    ?.find(
                                                        (product: any) =>
                                                            product.product ===
                                                            order.product,
                                                    )
                                                    ?.formats?.indexOf(
                                                        "PDF",
                                                    ) !== -1 ||
                                                    products
                                                        ?.find(
                                                            (product: any) =>
                                                                product.product ===
                                                                order.product,
                                                        )
                                                        ?.formats?.indexOf(
                                                            "XBRL",
                                                        ) !== -1) &&
                                                products?.find(
                                                    (product: any) =>
                                                        product.product ===
                                                        order.product,
                                                ),
                                        )
                                        .slice(0, 4)
                                        .map((order: OrderInterface) => {
                                            return (
                                                <BoughtOrderCard
                                                    order={order}
                                                    products={products}
                                                />
                                            );
                                        })}
                                </div>
                            </Typography>
                        </AccordionDetails>
                    </Accordion>
                </div>
            )}
        </div>
    );
};

export default BoughtDocumentsHeader;
